export enum EvaluationTypeEnum {
  Quiz = "QUIZ",
  Test = "TEST",
  Exam = "EXAM",
  Survey = "SURVEY",
}

export enum EvaluationTypeLabelEnum2 {
  QUIZ = "el quiz",
  TEST = "el test",
  EXAM = "el examen",
  SURVEY = "la encuesta",
}

export enum EvaluationTypeLabelEnum {
  QUIZ = "STUDENT_QUIZ",
  TEST = "STUDENT_TEST",
  EXAM = "STUDENT_EXAM",
  SURVEY = "STUDENT_SURVEY",
}

export enum RegisterEvaluationStatus {
  Registering = "Registering",
  Registered = "Registered",
  Error = "Error",
  Idle = "Idle",
}

export enum ParentTypeEnum {
  Lesson = "LESSON",
  Topic = "TOPIC",
  CourseExam = "COURSE_EXAM",
  CourseSurvey = "COURSE_SURVEY",
  Campaign = "CAMPAIGN",
}
